import { NX_MS_CLIENT_ID } from '@env/environment';

const REDIRECT_URI = window.location.origin;
const SCOPES = ['user.read', 'Files.ReadWrite'];

export class Onedrive {
  private static instance: Onedrive;
  private msalInstance;

  static getInstance() {
    if (!Onedrive.instance) {
      Onedrive.instance = new Onedrive();
    }
    return Onedrive.instance;
  }

  private async init() {
    if (!this.msalInstance) {
      const msal = await import('@azure/msal-browser');
      this.msalInstance = new msal.PublicClientApplication({
        auth: {
          clientId: NX_MS_CLIENT_ID,
          redirectUri: REDIRECT_URI,
        },
      });
    }
  }

  async getAccessToken() {
    await this.init();
    const { accessToken } = await this.msalInstance.loginPopup({
      scopes: SCOPES,
      redirectUri: REDIRECT_URI,
    });
    return accessToken;
  }
}
